interface LoadingProps {
  scope?: 'screen' | 'container'
  ariaLabel?: string
}

export default function Loading({ scope = 'screen', ariaLabel = 'Loading' }: LoadingProps) {
  const sizeClass = scope === 'container' ? 'h-full min-h-[320px]' : 'min-h-screen'

  return (
    <div
      className={`flex ${sizeClass} items-center justify-center`}
      role="status"
      aria-label={ariaLabel}
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
    </div>
  )
}
